import { generatePath } from 'react-router-dom'
import { PermissionDto } from 'api/Identity/Types/PermissionDto'
import { PermissionsEnum } from 'api/Identity/Types/PermissionsEnum'

import { links } from './featureToggles'
import { hasPermission } from './permissionsValidator'
import { TenantFeature } from './Tenant'

type OpenWindowOptions = {
  urlKey: TenantFeature
  permission?: PermissionsEnum
  permissions?: PermissionDto[]
  additionalParams?: Record<string, string>
  pathParams: Record<string, string | number>
}

export const handleOpenWindow = ({
  permissions,
  permission,
  urlKey,
  pathParams,
  additionalParams = {},
}: OpenWindowOptions): void => {
  if (permissions && permission && !hasPermission(permissions, permission)) return

  const testPath = generatePath(links[urlKey].detailsUrl as string, pathParams)
  const queryParams = new URLSearchParams(additionalParams).toString()
  const fullPath = queryParams.length ? `${testPath}?${queryParams}` : testPath

  window.open(fullPath, '_blank', 'location=yes,height=1000,width=520,scrollbars=yes,status=yes')
}
